"use strict";

module.exports = {
  apiServerUrl: 'https://api-staging.amplement.io',
  debug: true,
  env: 'staging',
  sentryEnabled: true,
  websocketHostname: 'https://api-staging.amplement.io'
};